import { getCookie, setCookie, removeCookie } from './cookies.js';
import { C as COOKIE_TOKEN_NAME, s as COOKIE_TOKEN_MAX_AGE_SEC } from '../cookies-l-jEMp6P.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import './isBot.js';

const getToken = (ctx) => String(getCookie(COOKIE_TOKEN_NAME, ctx) || '');
const setToken = (token) => {
    setCookie(COOKIE_TOKEN_NAME, token, { maxAge: COOKIE_TOKEN_MAX_AGE_SEC });
};
const removeToken = (ctx) => {
    removeCookie(COOKIE_TOKEN_NAME, ctx);
};
const isAuthenticated = (ctx) => Boolean(getToken(ctx));

export { getToken, isAuthenticated, removeToken, setToken };
//# sourceMappingURL=auth.js.map
